import React, { ComponentType } from "react";
import { react2Angular } from "~/Core/React2Angular";
import { TS } from "~/Services/TS";
import { useOptionsContext } from "~/Contexts/OptionsContext";
import Cookies from "js-cookie";
import { useSingleSpaParcel } from "~/Hooks/SingleSpaParcel";

export const PaymentService = () => {
    let options = useOptionsContext();

    let parcel = useSingleSpaParcel("@optimizely/payment-service", {
        environmentKey: options.payment.spreedlyEnvironmentKey,
        turnstileInstanceId: options.turnstile.instanceId,
        turnstileMasterCustomerId: options.turnstile.masterCustomerId,
        turnstileOrganizationId: options.turnstile.organizationId,
        turnstileOrganizationName: options.turnstile.organizationName,
        subProductName: "Configured Commerce",
        accessToken: Cookies.get("opti_id_token"),
    });

    if (parcel === null) {
        return null;
    }

    return (
        <div className="grid-block vertical">
            <div className="title-bar">
                <div className="instructions">
                    <span>{TS("The Payment Service configuration page")}</span>
                </div>
            </div>

            <div className="title-bar">
                <h1 className="title left">{TS("Payment Service")}</h1>
            </div>

            <div className="grid-block">
                <div className="parcel-container">{parcel}</div>
            </div>
        </div>
    );
};

angular.module("insite-admin").component("paymentService", react2Angular(PaymentService));
